import { compare } from 'compare-versions';

import { SolutionVersionDTO } from '../../common/api/models/solution';

export const getLatestSolutionVersion = (
  originals: SolutionVersionDTO[]
): SolutionVersionDTO | undefined => {
  if (originals.length === 0) {
    return;
  }

  return originals.sort((a, b) => {
    if (compare(a.version, b.version, '>')) return -1;
    return 1;
  })[0];
};
